import React, { useRef, useEffect } from "react";

const ContractModal = ({ isOpen, onClose, children, pdfUrl }) => {
    // console.log("ContractModal rendered.", isOpen);
    
    const modalRef = useRef(null); 

    // Handle closing the modal when clicking outside
    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };

    // Add an event listener to detect clicks outside the modal
    React.useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        // Cleanup the event listener when component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null; 

    useEffect(() => {
        if (pdfUrl) {
          const objectElement = document.getElementById('pdfObject');
          if (objectElement) {
            objectElement.data = pdfUrl;
          }
        }
      }, [pdfUrl]);

    return (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-50">
            <div ref={modalRef} className="bg-white p-8 rounded-lg shadow-lg w-[1200px] max-h-[725px] overflow-y-scroll">
            <button className="absolute right-44 hover:bg-slate-200 p-2 rounded-lg" onClick={onClose}>Close</button>
                {children}
            </div>
        </div>
    );
};

export default ContractModal; 